export default __webpack_public_path__ + "static/misc-1a29c54894352d1df2e3e18f44146085.png";